import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { STOCK_API_BASE, STOCK_PK_API } from '../../../consts';
import { UserStockModel } from './userStock.model';
import { ApiResponse } from '../../../models/base';

const LIST_ENDPOINT = '/stock';
const API_ENDPOINT_LOGIN = '/securize/user';
const API_ENDPOINT = '/api/user/list';

@Injectable({
  providedIn: 'root',
})
export class UserStockService {
  userStock: UserStockModel | null = null;

  private readonly http = inject(HttpClient);

  async loadData(): Promise<UserStockModel> {
    const response = await firstValueFrom(
      this.http.get<ApiResponse<UserStockModel>>(environment.apiUrl + LIST_ENDPOINT)
    );

    return response.data;
  }

  async editData(userStock: UserStockModel): Promise<UserStockModel> {
    return await firstValueFrom(
      this.http.put<UserStockModel>(environment.apiUrl + LIST_ENDPOINT, userStock)
    );
  }

  async login(username: string, password: string): Promise<any> {
    const headers = new HttpHeaders({
      Accept: '*/*',
      username,
      password,
      secret: STOCK_PK_API,
    });

    try {
      return await firstValueFrom(
        this.http.post(STOCK_API_BASE + API_ENDPOINT_LOGIN, null, { headers })
      );
    } catch (error) {
      return error;
    }
  }
}